<template>
  <v-row justify="center" dense>
    <v-col cols="12" lg="10" md="10" v-if="dataSource.series[0].data.length">
      <MixedCarts :dataSource="dataSource" />
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "OnboardingReco",
  components: {
    MixedCarts,
  },
  data() {
    return {
      elements: [
        "gender",
        "first_reco_popularity",
        "first_reco_product_type_male",
        "first_reco_product_type_female",
        "product_type",
        "sub-category",
        "sub-sub-category",
        "size",
        "brands",
        "first_reco",
        "second_reco",
        "third_reco",
        "criteria_product",
        "quiz",
      ],
      dataSource: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  mounted() {
    this.set_data();
  },
  methods: {
    set_data() {
      for (let i = 0; i < this.elements.length; i++) {
        const element = this.elements[i];
        const res = Object.entries(this.onboarding).find((data) => {
          if (data[0] === element) return data;
        });
        if (res) {
          const key = res[0];
          const value = res[1];
          this.dataSource.series[0].data.push({
            x: this.store_config.i18n[this.$i18n.locale].buttons[key]
              ? this.store_config.i18n[this.$i18n.locale].buttons[key].split(
                  "&"
                )[0]
              : this.store_config.i18n[this.$i18n.locale].buttons[key] || key,
            y: value,
          });
        }
        //  else {
        //   console.log(element, "null");
        // }
      }
    },
  },
};
</script>
